export enum Languages {
    RU = 1,
    EN = 2,
    CH = 3
}
